// utilidades para persistir consentimiento de cookies
const KEY = 'itinerario_cookie_consent_v1';

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function saveConsent(obj) {
  try {
    const payload = { ...obj, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
    return payload;
  } catch (e) {
    return null;
  }
}

export function clearConsent() {
  try { localStorage.removeItem(KEY); } catch (e) {}
}
